/* Window Visors landing — shared behavior (extracted). Run-once guarded. */
if (!window.__wvLandingInit) { window.__wvLandingInit = true;

  document.addEventListener("DOMContentLoaded", function () {
    var sliderWrap = document.getElementById("sa-ba-slider");
    var range = document.getElementById("sa-ba-range");
    var after = document.getElementById("sa-ba-after");
    var divider = document.getElementById("sa-ba-divider");

    var beforeImg = document.getElementById("sa-ba-before-img");
    var afterImg = document.getElementById("sa-ba-after-img");
    var loupe = document.getElementById("sa-ba-loupe");
    var loupeBefore = document.getElementById("sa-ba-loupe-before");
    var loupeAfter = document.getElementById("sa-ba-loupe-after");

    var zoomOutBtn = document.getElementById("sa-zoom-out");
    var zoomInBtn = document.getElementById("sa-zoom-in");
    var zoomResetBtn = document.getElementById("sa-zoom-reset");
    var zoomValue = document.getElementById("sa-zoom-value");

    var zoom = 1;
    var minZoom = 1;
    var maxZoom = 1.8;
    var zoomStep = 0.1;

    var loupeZoom = 1.8;
    var loupeMinZoom = 1;
    var loupeMaxZoom = 8;
    var loupeStep = 0.35;

    var lastLoupeClientX = null;
    var lastLoupeClientY = null;

    var sliderValue = range ? Number(range.value) : 50;

    function updateSlider(value) {
      if (!after || !divider || !sliderWrap) return;
      sliderValue = Number(value);
      var rightClip = 100 - sliderValue;
      after.style.clipPath = "inset(0 " + rightClip + "% 0 0)";
      divider.style.left = sliderValue + "%";
      if (lastLoupeClientX !== null && lastLoupeClientY !== null) {
        moveLoupe(lastLoupeClientX, lastLoupeClientY);
      }
    }

    function updateZoom() {
      if (!sliderWrap) return;
      sliderWrap.style.setProperty("--sa-ba-zoom", zoom.toFixed(2));
      if (zoomValue) {
        zoomValue.textContent = Math.round(zoom * 100) + "%";
      }
    }

    function setupLoupeImages() {
      if (!beforeImg || !afterImg || !loupeBefore || !loupeAfter) return;
      loupeBefore.style.backgroundImage = "url('" + beforeImg.src + "')";
      loupeAfter.style.backgroundImage = "url('" + afterImg.src + "')";
    }

    function getRenderedImageData(img) {
      // Measure the image as actually rendered (includes the zoom transform),
      // then map the natural image into that box per computed object-fit /
      // object-position - the CSS uses cover, so a contain assumption drifts.
      var box = img.getBoundingClientRect();
      if (!img || !img.naturalWidth || !img.naturalHeight) {
        return { left: box.left, top: box.top, displayWidth: box.width, displayHeight: box.height };
      }
      var style = getComputedStyle(img);
      var fit = style.objectFit || "fill";
      var scaleX = box.width / img.naturalWidth;
      var scaleY = box.height / img.naturalHeight;
      var scale = fit === "contain" ? Math.min(scaleX, scaleY) : fit === "cover" ? Math.max(scaleX, scaleY) : null;
      var displayWidth = scale === null ? box.width : img.naturalWidth * scale;
      var displayHeight = scale === null ? box.height : img.naturalHeight * scale;
      function axisOffset(token, boxSize, dispSize) {
        if (!token) return (boxSize - dispSize) / 2;
        if (token.indexOf("%") !== -1) return (boxSize - dispSize) * (parseFloat(token) / 100);
        return parseFloat(token) || 0;
      }
      var pos = (style.objectPosition || "50% 50%").split(" ");
      return {
        left: box.left + axisOffset(pos[0], box.width, displayWidth),
        top: box.top + axisOffset(pos[1], box.height, displayHeight),
        displayWidth: displayWidth,
        displayHeight: displayHeight
      };
    }

    function updateLoupeClip(xPercent) {
      if (!sliderWrap) return;
      var relativeClip = sliderValue >= xPercent ? 0 : 100;
      sliderWrap.style.setProperty("--sa-loupe-after-clip", "inset(0 " + relativeClip + "% 0 0)");
    }

    // Returns true if the given client point is inside the round center handle.
    function isOverHandle(clientX, clientY) {
      if (!sliderWrap) return false;
      var handleEl = sliderWrap.querySelector(".sa-ba-handle");
      if (!handleEl) return false;
      var hRect = handleEl.getBoundingClientRect();
      var hcx = hRect.left + hRect.width / 2;
      var hcy = hRect.top + hRect.height / 2;
      var dist = Math.sqrt(Math.pow(clientX - hcx, 2) + Math.pow(clientY - hcy, 2));
      return dist <= hRect.width / 2;
    }

    function moveLoupe(clientX, clientY) {
      if (!sliderWrap || !loupe || !beforeImg || !afterImg || !loupeBefore || !loupeAfter) return;
      var rect = sliderWrap.getBoundingClientRect();
      var x = clientX - rect.left;
      var y = clientY - rect.top;
      lastLoupeClientX = clientX;
      lastLoupeClientY = clientY;

      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        sliderWrap.classList.remove("is-loupe-active");
        sliderWrap.classList.remove("is-handle-hover");
        sliderWrap.style.cursor = "";
        return;
      }

      // Hovering the center handle: hide the loupe and show a normal cursor.
      if (isOverHandle(clientX, clientY)) {
        sliderWrap.classList.add("is-handle-hover");
        sliderWrap.classList.remove("is-loupe-active");
        sliderWrap.style.cursor = "default";
        return;
      } else {
        sliderWrap.classList.remove("is-handle-hover");
        sliderWrap.style.cursor = "";
      }

      var xPercent = (x / rect.width) * 100;
      var yPercent = (y / rect.height) * 100;
      var beforeData = getRenderedImageData(beforeImg);
      var afterData = getRenderedImageData(afterImg);
      var loupeSize = parseFloat(getComputedStyle(sliderWrap).getPropertyValue("--sa-loupe-size")) || 176;
      var beforeBgWidth = beforeData.displayWidth * loupeZoom;
      var beforeBgHeight = beforeData.displayHeight * loupeZoom;
      var afterBgWidth = afterData.displayWidth * loupeZoom;
      var afterBgHeight = afterData.displayHeight * loupeZoom;
      var beforeBgX = -((clientX - beforeData.left) * loupeZoom - loupeSize / 2);
      var beforeBgY = -((clientY - beforeData.top) * loupeZoom - loupeSize / 2);
      var afterBgX = -((clientX - afterData.left) * loupeZoom - loupeSize / 2);
      var afterBgY = -((clientY - afterData.top) * loupeZoom - loupeSize / 2);
      loupeBefore.style.backgroundSize = beforeBgWidth + "px " + beforeBgHeight + "px";
      loupeBefore.style.backgroundPosition = beforeBgX + "px " + beforeBgY + "px";
      loupeAfter.style.backgroundSize = afterBgWidth + "px " + afterBgHeight + "px";
      loupeAfter.style.backgroundPosition = afterBgX + "px " + afterBgY + "px";
      sliderWrap.style.setProperty("--sa-loupe-x", xPercent + "%");
      sliderWrap.style.setProperty("--sa-loupe-y", yPercent + "%");
      updateLoupeClip(xPercent);
      sliderWrap.classList.add("is-loupe-active");
    }

    function handleLoupeWheel(event) {
      if (!sliderWrap) return;
      event.preventDefault();
      if (event.deltaY < 0) {
        loupeZoom = Math.min(loupeMaxZoom, loupeZoom + loupeStep);
      } else {
        loupeZoom = Math.max(loupeMinZoom, loupeZoom - loupeStep);
      }
      if (event.clientX && event.clientY) {
        moveLoupe(event.clientX, event.clientY);
      }
    }

    setupLoupeImages();

    if (range) {
      range.addEventListener("input", function () { updateSlider(range.value); });
      range.addEventListener("mousemove", function (event) { moveLoupe(event.clientX, event.clientY); });
      if (loupe) { range.addEventListener("wheel", handleLoupeWheel, { passive: false }); }
      range.addEventListener("touchmove", function (event) {
        if (!event.touches || !event.touches.length) return;
        moveLoupe(event.touches[0].clientX, event.touches[0].clientY);
      }, { passive: true });
      updateSlider(range.value);
    }

    if (sliderWrap) {
      sliderWrap.addEventListener("mousemove", function (event) { moveLoupe(event.clientX, event.clientY); });
      sliderWrap.addEventListener("mouseleave", function () {
        sliderWrap.classList.remove("is-loupe-active");
        sliderWrap.classList.remove("is-handle-hover");
        sliderWrap.style.cursor = "";
      });
      if (loupe) { sliderWrap.addEventListener("wheel", handleLoupeWheel, { passive: false }); }
      sliderWrap.addEventListener("touchstart", function (event) {
        if (!event.touches || !event.touches.length) return;
        moveLoupe(event.touches[0].clientX, event.touches[0].clientY);
      }, { passive: true });
      sliderWrap.addEventListener("touchmove", function (event) {
        if (!event.touches || !event.touches.length) return;
        moveLoupe(event.touches[0].clientX, event.touches[0].clientY);
      }, { passive: true });
      sliderWrap.addEventListener("touchend", function () { sliderWrap.classList.remove("is-loupe-active"); });
    }

    if (zoomOutBtn) { zoomOutBtn.addEventListener("click", function () { zoom = Math.max(minZoom, zoom - zoomStep); updateZoom(); }); }
    if (zoomInBtn) { zoomInBtn.addEventListener("click", function () { zoom = Math.min(maxZoom, zoom + zoomStep); updateZoom(); }); }
    if (zoomResetBtn) { zoomResetBtn.addEventListener("click", function () { zoom = 1; updateZoom(); }); }

    updateZoom();

    var brandSelect = document.getElementById("sa-brand-select");
    var modelSelect = document.getElementById("sa-model-select");
    var yearSelect = document.getElementById("sa-year-select");
    var findBtn = document.getElementById("sa-find-visor");

    var models = {
      bmw: ["3 Series", "5 Series", "X3", "X5", "M3", "M4"],
      ford: ["Mustang", "F-150", "Explorer", "Bronco", "Focus", "Fusion"],
      toyota: ["Camry", "Corolla", "RAV4", "Tacoma", "4Runner", "Prius"],
      honda: ["Civic", "Accord", "CR-V", "HR-V", "Pilot", "Odyssey"],
      subaru: ["WRX", "BRZ", "Forester", "Outback", "Crosstrek", "Impreza"],
      nissan: ["Altima", "Sentra", "Maxima", "370Z", "350Z", "Rogue"],
      chevrolet: ["Camaro", "Corvette", "Silverado", "Malibu", "Tahoe", "Suburban"]
    };

    if (brandSelect && modelSelect) {
      brandSelect.addEventListener("change", function () {
        var brand = brandSelect.value;
        var list = models[brand] || [];
        modelSelect.innerHTML = '<option value="">Select Model</option>';
        list.forEach(function (model) {
          var option = document.createElement("option");
          option.value = model.toLowerCase().replace(/\s+/g, "-");
          option.textContent = model;
          modelSelect.appendChild(option);
        });
      });
    }

    if (findBtn) {
      findBtn.addEventListener("click", function () {
        var brand = brandSelect ? brandSelect.value : "";
        var model = modelSelect ? modelSelect.value : "";
        var year = yearSelect ? yearSelect.value : "";
        if (!brand) { alert("Please select a brand."); return; }
        var searchParts = [];
        if (brand) searchParts.push(brand);
        if (model) searchParts.push(model.replace(/-/g, " "));
        if (year) searchParts.push(year);
        searchParts.push("window visor");
        window.location.href = "/search?type=product&q=" + encodeURIComponent(searchParts.join(" "));
      });
    }

    var directSearchForm = document.querySelector(".sa-direct-search-form");
    var directSearchInput = document.getElementById("sa-direct-search-input");

    if (directSearchForm && directSearchInput) {
      directSearchForm.addEventListener("submit", function (event) {
        var keyword = directSearchInput.value.trim();
        if (!keyword) {
          event.preventDefault();
          alert("Please enter a search keyword.");
          directSearchInput.focus();
        }
      });
    }
  });

}
